import * as React from 'react'

import linkGenerator, { type PositionalProperties } from 'modules/people_chart/lib/linkGenerator'

import * as styles from './index.vanilla.css'

type Props = {
  source: PositionalProperties
  target: PositionalProperties
}
const Link: React.FC<Props> = ({ source, target }) => {
  const d = linkGenerator(source, target)

  if (!d) {
    return null
  }

  return <path d={d} className={styles.link} />
}

export default Link
